export default __webpack_public_path__ + "static/media/7B5_jakeattreasureisland_e.dd5ddb13.png";